<template>
  <div class="live-chat-home-wrapper" ref="liveChatHomeWrapper">
    <CommonSearchFilter
          :anySearchOrFilterIsApplied="anySearchOrFilterIsApplied"
          :agentFocusedMode="agentFocusedMode"
          :filteredChannels="filteredChannels"
          :showAddChat="whatsappConnected || googlercsConnected || smsConnected"
          :showQuickShortcuts="true"
          :showFilterOptions="true"
          :showClearFilterBar="false"
          :allAgents="allAgents"
          placeholder="Search chats"
          @search="onSearchBarSearch"
          @filter="onSearchBarFilter"
          @clear="onSearchBarClear"
          @add-edit-modal="$emit('addEditModal')"
        >

          <div v-if="customersResults.length > 0 || loadingCustomers">
            <div v-if="show_liveChatConversationsListAreaTabs == true" class="cursorPointer">
            <div class="custom-tabs">
              <div class="custom-tab" :class="{ active: active_conversationsListTab === 'activeChatsTab' }" @click="active_conversationsListTab = 'activeChatsTab'">
                <div class="newMessageAlertBubbleForSingleChatTab" v-if="checkAndShowTabSpecificUnreadMessageBubble('activeChatsTab') == true"></div>
                Active chats
              </div>
              <div class="custom-tab" :class="{ active: active_conversationsListTab === 'requestsChatsTab' }" @click="active_conversationsListTab = 'requestsChatsTab'">
                <div class="newMessageAlertBubbleForSingleChatTab" v-if="checkAndShowTabSpecificUnreadMessageBubble('requestsChatsTab') == true"></div>
                Requests
              </div>
              <div class="custom-tab" :class="{ active: active_conversationsListTab === 'botChatsTab' }" @click="active_conversationsListTab = 'botChatsTab'">
                <div class="newMessageAlertBubbleForSingleChatTab" v-if="checkAndShowTabSpecificUnreadMessageBubble('botChatsTab') == true"></div>
                Bot
              </div>
            </div>

              <div v-if="active_conversationsListTab == 'activeChatsTab'">
                <div class="chat-list">
                  <div :class="active === customer.conversationid ? 'liveChatListActive' : 'liveChatList'" v-for="customer in activeChatsTab_customersResults" :key="customer.id" @click="customer.count = 0; $emit('customer', customer.conversationid)">
                    <singleChatListCard :customer="customer" />
                  </div>
                </div>

                <div class="text-center custResultsArea" v-if="activeChatsTab_customersResults.length == 0 && activeChatsTab_customersResultsLoading == false" >
                  <img src="../resources/images/empty_purchases.svg" class="emptyFiltersImage" alt="empty-purchases"/>
                  <p class="sub-title" v-if="fetchCustomerApiCalledFor_activeChatsTab == false">Click on "Load more" button to view all your active conversations.</p>
                  <p class="sub-title" v-if="fetchCustomerApiCalledFor_activeChatsTab == true" >Seems like you don't have any active chats 💬</p>
                  <a style="display: flex; justify-content: center; margin: 30px 0;" v-if="fetchCustomerApiCalledFor_activeChatsTab == false" @click="fetchCustomers(null, activeChatsTab_currentPaginationNumber+1,false,'activeChatsTab')" >Load more</a>
                </div>

                <div class="text-center" v-if="activeChatsTab_customersResults.length == 0 && activeChatsTab_customersResultsLoading == true"  >
                  <img src="../resources/images/empty_purchases.svg" emptyFiltersImage alt="empty_purchases" />
                  <h5>Fetching customers...</h5>
                </div>
              </div>
              <div v-if="active_conversationsListTab == 'requestsChatsTab'">
                <div class="chat-list">
                  <div :class="active === customer.conversationid ? 'liveChatListActive' : 'liveChatList'" v-for="customer in (requestsChatsTab_customersResults || cloneRequestsChatsTab_customersResults)" :key="customer.id" @click="customer.count = 0; $emit('customer', customer.conversationid)" lines="full">
                    <singleChatListCard :customer="customer" />
                  </div>
                </div>

                <div class="text-center custResultsArea" v-if="requestsChatsTab_customersResults.length == 0 && requestsChatsTab_customersResultsLoading == false">
                  <img src="../resources/images/empty_purchases.svg" class="emptyFiltersImage" alt="empty_purchases"/>
                  <p class="sub-title" v-if="fetchCustomerApiCalledFor_requestsChatsTab == false">Click on "Load more" button to view all your active conversations.</p>
                  <p class="sub-title"  v-if="fetchCustomerApiCalledFor_requestsChatsTab == true" >Seems like no one needs help for now... good job 👍</p>
                  <a style="display: flex; justify-content: center; margin: 30px 0;" v-if="fetchCustomerApiCalledFor_requestsChatsTab == false" @click="fetchCustomers(null, requestsChatsTab_currentPaginationNumber+1,false,'requestsChatsTab')" >Load more</a>
                </div>

                <div class="text-center" v-if="requestsChatsTab_customersResults.length == 0 && requestsChatsTab_customersResultsLoading == true">
                  <img src="../resources/images/empty_purchases.svg" emptyFiltersImage alt="empty_purchases" />
                  <h5>Fetching customers...</h5>
                </div>
              </div>
              <div v-if="active_conversationsListTab == 'botChatsTab'">
                <div class="chat-list">
                  <div :class="active === customer.conversationid ? 'liveChatListActive' : 'liveChatList'" v-for="customer in botChatsTab_customersResults" :key="customer.id" @click="customer.count = 0; $emit('customer', customer.conversationid)" lines="full">
                    <singleChatListCard :customer="customer" />
                  </div>
                </div>
                
                <div class="text-center custResultsArea" v-if="botChatsTab_customersResults.length == 0 && botChatsTab_customersResultsLoading == false">
                  <img src="../resources/images/empty_purchases.svg" class="emptyFiltersImage"/>
                  <p class="sub-title" v-if="fetchCustomerApiCalledFor_botChatsTab == false">Click on "Load more" button to view all your active conversations.</p>
                  <p class="sub-title" v-if="fetchCustomerApiCalledFor_botChatsTab == true" >Seems like no one is interacting with your bot 🤖</p>
                  <a style="display: flex; justify-content: center; margin: 30px 0;" v-if="fetchCustomerApiCalledFor_botChatsTab == false" @click="fetchCustomers(null, botChatsTab_currentPaginationNumber+1,false,'botChatsTab')" >Load more</a>
                </div>

                <div class="text-center" v-if="botChatsTab_customersResults.length == 0 && botChatsTab_customersResultsLoading == true">
                  <img src="../resources/images/empty_purchases.svg" emptyFiltersImage />
                  <h5>Fetching customers...</h5>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="chat-list">
                <div :class="active === customer.conversationid ? 'liveChatListActive' : 'liveChatList'" v-for="customer in customersResultsToLoad" :key="customer.id" @click="customer.count = 0; $emit('customer', customer.conversationid)" lines="full">
                  <singleChatListCard :customer="customer" /> 
                </div>
              </div>
            </div>
          </div>
          <!-- infinite scroll: sentinel is watched by an IntersectionObserver and loads the next page of conversations -->
          <div ref="customersListSentinel" class="customersListSentinel"></div>
          <div class="text-center customersListLoadingMore" v-if="isLoadingMoreCustomers">
            <VProgressRing connotation="cta" :size="-5" />
            <span class="sub-title">Loading more conversations...</span>
          </div>
          <div class="text-center emptyResults" v-if="customersResults.length == 0 && !loadingCustomers">                
            <img src="../resources/images/not-found.svg" alt="not_found" class="emptyFiltersImage" />
            <h5>No customers yet! 😟</h5>
            <h5 class="text-agent">Seems like the one you're looking for, hasn't interacted with you yet</h5>
          </div>
          <div class="text-center emptyResults" v-if="loadingCustomers && customersResults.length == 0">                
            <img src="../resources/images/not-found.svg" alt="not_found"  class="emptyFiltersImage" />
            <h5>Fetching your customers...</h5>
          </div>
        </CommonSearchFilter>
  </div>
</template>

<script>

import apiInterceptor from '@/shared/apiInterceptor';
import { calculate24Plus1RuleForCustomer } from '@/helpers/chat.helpers';
/* import components */
import singleChatListCard from "../components/singleChatListCard.vue";
import CommonSearchFilter from "../components/CommonSearchFilter.vue";
import whatsappIcon from '@/resources/images/whatsapp_icon.svg';
import smsLogo from '@/resources/images/sms_logo.svg';
import googleRcsIcon from '@/resources/images/Google_RCS_icon.svg';
import { queryClient } from '@/shared/queryClient';
import { teamMembersQueryOptions } from '@/composables/useTeamMembers';
import { livechatShortcutsQueryOptions } from '@/composables/useLivechatShortcuts';
import { livechatBusinessRolesQueryOptions } from '@/composables/useLivechatBusinessRoles';
import { useAuthStore } from '@/stores/auth';
import { useUIStore } from '@/stores/ui';
import { useSocialChannels } from '@/composables/useSocialChannels';
import { useRoleDetails } from '@/composables/useRoleDetails';
import { environment } from '@/shared/env';
import { uniqueObjectiveArray } from '@/helpers/global.helpers.js';

export default {
  mixins: [],
  components: { singleChatListCard, CommonSearchFilter },
  emits: ["customer", "onFilterCustomers", "onClearFilter", "addEditModal"],
  props: {
    active: { type: String, default: undefined, },
  },
  setup() {
    const { whatsappConnected, googlercsConnected, smsConnected, getChannelFromPageActive } = useSocialChannels();
    const { roleDetails } = useRoleDetails();
    return { whatsappConnected, googlercsConnected, smsConnected, getChannelFromPageActive, roleDetails };
  },
  data() {
    return {
      whatsappIcon,
      totalCustomers_loadMore: false,
      activeChatsTab_totalCustomers_loadMore: false,
      requestsChatsTab_totalCustomers_loadMore: false,
      botChatsTab_totalCustomers_loadMore: false,
      activeCustomer: {},
      activeChatsTab_customersResults: [],
      requestsChatsTab_customersResults: [],
      botChatsTab_customersResults: [],
      selectedChannel: "all",
      customersResultsLoading: true,
      activeChatsTab_customersResultsLoading: true,
      requestsChatsTab_customersResultsLoading: true,
      botChatsTab_customersResultsLoading: true,
      fetchCustomerApiCalledFor_activeChatsTab: false,
      fetchCustomerApiCalledFor_requestsChatsTab: false,
      fetchCustomerApiCalledFor_botChatsTab: false,
      currentPaginationNumber: 1,
      activeChatsTab_currentPaginationNumber: 1,
      requestsChatsTab_currentPaginationNumber: 1,
      botChatsTab_currentPaginationNumber: 1,
      searchByFirstNameText: "",
      searchByLastNameText: "",
      searchByEmailText: "",
      searchByTagText: "",
      searchByMobileNumberText: "",
      searchByCustomFieldText: "",
      searchByCustomFieldKey: "",
      searchByAssignedToMeText: false,
      searchByAssignedToBotText: false,
      searchByAssignedToAgentText: "",
      searchByAssignedToAgentID: "",
      searchByUnassignedConvoText: false,
      searchByFollowupText: false,
      searchByArchivedUsersText: false,
      subscriptionStatus: '',
      nextCursor: undefined,
      activeChatsTab_nextCursor: undefined,
      requestsChatsTab_nextCursor: undefined,
      botChatsTab_nextCursor: undefined,
      anySearchOrFilterIsApplied: false,
      filterVal: undefined,
      agentFocusedMode: false,
      show_liveChatConversationsListAreaTabs: false,
      liveChatConversationsView_type: "1tabView",
      active_conversationsListTab: "activeChatsTab",
      normalPusherNotifications: [],
      loadingCustomers: false,
      cloneCustomersResults: [],
      allAgents: [],
      customersResults: [],
      isWhatsappChat_old24H: false,
      commonSearchFilterRenderKey: 0,
      isLoadingMoreCustomers: false,
      customersListSentinelIsVisible: false,
      customersListAutoLoadBlocked: false,
      customersListObserver: null,
      observedCustomersListSentinel: null,
    };
  },
  computed: {
    group_id() { return useAuthStore().authData?.group_id; },
    customersResultsToLoad() {
      if (this.customersResults.length) {
        return this.sortCustomersByLastReply([...this.customersResults]);
      }
      return this.sortCustomersByLastReply([...this.cloneCustomersResults]);
    },
    channels() {
      return [
        {
          key: 'whatsapp',
          label: 'WhatsApp',
          image: whatsappIcon,
          isConnected: this.whatsappConnected,
        },
        {
          key: 'googlercs',
          label: 'Google RCS',
          image: googleRcsIcon,
          isConnected: this.googlercsConnected,
        },
        {
          key: 'sms',
          label: 'SMS',
          image: smsLogo,        
          isConnected: this.smsConnected,
        },
      ];
    },
    filteredChannels() {
      return this.channels.filter(
        (channel) => channel.isConnected && !this.agentFocusedMode && (channel.key == 'whatsapp' || channel.key == 'googlercs' || channel.key == 'sms')
      );
    },
    // ---- infinite scroll helpers (resolve the list currently on screen) ----
    currentListTabBasedFilter() {
      if (this.show_liveChatConversationsListAreaTabs == true) {
        return this.active_conversationsListTab;
      }
      return "";
    },
    currentListPaginationNumber() {
      if (this.show_liveChatConversationsListAreaTabs == true) {
        if (this.active_conversationsListTab == "activeChatsTab") return this.activeChatsTab_currentPaginationNumber;
        if (this.active_conversationsListTab == "requestsChatsTab") return this.requestsChatsTab_currentPaginationNumber;
        if (this.active_conversationsListTab == "botChatsTab") return this.botChatsTab_currentPaginationNumber;
      }
      return this.currentPaginationNumber;
    },
    currentListLoadedCount() {
      if (this.show_liveChatConversationsListAreaTabs == true) {
        if (this.active_conversationsListTab == "activeChatsTab") return this.activeChatsTab_customersResults.length;
        if (this.active_conversationsListTab == "requestsChatsTab") return this.requestsChatsTab_customersResults.length;
        if (this.active_conversationsListTab == "botChatsTab") return this.botChatsTab_customersResults.length;
      }
      return this.customersResults.length;
    },
    hasMoreCustomersToLoad() {
      if (this.currentListLoadedCount <= 0) return false;
      if (this.show_liveChatConversationsListAreaTabs == true) {
        if (this.active_conversationsListTab == "activeChatsTab") return this.activeChatsTab_totalCustomers_loadMore;
        if (this.active_conversationsListTab == "requestsChatsTab") return this.requestsChatsTab_totalCustomers_loadMore;
        if (this.active_conversationsListTab == "botChatsTab") return this.botChatsTab_totalCustomers_loadMore;
      }
      return this.totalCustomers_loadMore;
    },
  },
  async mounted() {
    await this.init();
    try {
      await this.ensureActiveConversationVisible(this.active);
      const [agentsResponseData] = await Promise.all([
        queryClient.ensureQueryData(teamMembersQueryOptions),
        queryClient.ensureQueryData(livechatShortcutsQueryOptions),
        queryClient.ensureQueryData(livechatBusinessRolesQueryOptions),
      ]);
      if (agentsResponseData?.length) {
        this.allAgents = agentsResponseData;
      } else {
        console.error("Response:", agentsResponseData);
      }
    } catch (e) {
      console.error("Exception in fetching active user not in the list: ", e);
    }
    
    // Add event listeners
    document.addEventListener("new-message", this.newMessageHandler, true);
    document.addEventListener( "new-message-via-agent-routing", this.newMessageHandler_via_agentRouting, true );
    document.addEventListener( "remove-conversation", this.removeConversationHandler, true );
    document.addEventListener( "reassign-conversation", this.reassignConversationHandler, true );
    document.addEventListener( "refresh-customers", this.refreshCustomersHandler, true );
    document.addEventListener( "refresh-page", this.refreshPageHandler, true );
    document.addEventListener( "customer_info_update", this.pre_updateCustomerMarketingOptinStatusHandler, true );

    this.$nextTick(() => this.observeCustomersListSentinel());
  },
  updated() {
    // the conversations list (and therefore the sentinel) is rendered inside
    // CommonSearchFilter's slot, so re-attach the observer whenever it is re-created
    this.observeCustomersListSentinel();
  },
  watch: {
    active_conversationsListTab() {
      this.customersListAutoLoadBlocked = false;
      this.$nextTick(() => this.maybeLoadMoreCustomers());
    },
    loadingCustomers(isLoading) {
      // a freshly loaded page can be shorter than the viewport, keep filling it
      if (isLoading == false) {
        this.$nextTick(() => this.maybeLoadMoreCustomers());
      }
    },
    async '$route.path'(n, o) {
      const conversationId = this.$route?.query?.conversation;
      if (n === '/page-inbox' && o !== '/page-inbox' && conversationId) {
        await this.resetFiltersForExternalConversationNavigation();
      }
    },
    async active(n, o) {
      if(n && n !== o) {
        await this.ensureActiveConversationVisible(n);
      }
    }
  },
  methods: {
    calculate24Plus1RuleForCustomer,
    buildConversationSummary(inboxData, conversationId) {
      return {
        active: inboxData.active,
        assigned_to: inboxData.assigned_to,
        channel: inboxData.platform,
        channel_id: inboxData.channel,
        conversationid: conversationId,
        currentlyOpendChat: true,
        email: inboxData.email,
        image: inboxData.image,
        lastReplyTimestamp: inboxData.lastReplyTimestamp,
        name: inboxData.name,
        status: inboxData.status,
        userReplyTimestamp: inboxData.userReplyTimestamp,
      };
    },
    async ensureActiveConversationVisible(conversationId) {
      // Reject missing or literal "undefined" ids so we never build an
      // invalid URL like crm/v1/customers/undefined [APICC-3238].
      if (!conversationId || conversationId === 'undefined') return;

      try {
        const customerIndex = this.customersResults.findIndex((e) => e.conversationid === conversationId);
        let activeConversation;

        if (customerIndex >= 0) {
          activeConversation = this.customersResults.splice(customerIndex, 1)[0];
          activeConversation.currentlyOpendChat = true;
        } else {
          const inboxResponse = await apiInterceptor.get(environment("VUE_APP_API_URL") + "crm/v1/customers/" + conversationId);
          if (!inboxResponse?.data) return;
          activeConversation = this.buildConversationSummary(inboxResponse.data, conversationId);
        }

        this.customersResults.unshift(activeConversation);
        this.customersResults = this.sortCustomersByLastReply(this.customersResults);

        if (this.show_liveChatConversationsListAreaTabs == true) {
          this.adjustNew_customerData_intoTabs(activeConversation);
          this.activeChatsTab_customersResults = this.sortCustomersByLastReply(this.activeChatsTab_customersResults);
          this.requestsChatsTab_customersResults = this.sortCustomersByLastReply(this.requestsChatsTab_customersResults);
          this.botChatsTab_customersResults = this.sortCustomersByLastReply(this.botChatsTab_customersResults);

          if (this.checkIfChatIsAssignedToMe(activeConversation)) {
            this.active_conversationsListTab = "activeChatsTab";
          } else if (this.checkIfChatIsUnassigned(activeConversation)) {
            this.active_conversationsListTab = "requestsChatsTab";
          } else if (this.checkIfChatIsAssignedToBot(activeConversation)) {
            this.active_conversationsListTab = "botChatsTab";
          }
        }
      } catch (e) {
        console.error("Exception in fetching active user not in the list: ", e);
      }
    },
    async resetFiltersForExternalConversationNavigation() {
      this.searchByFirstNameText = "";
      this.searchByLastNameText = "";
      this.searchByEmailText = "";
      this.searchByMobileNumberText = "";
      this.searchByTagText = "";
      this.searchByAssignedToAgentText = "";
      this.searchByAssignedToAgentID = "";
      this.selectedChannel = "all";
      this.searchByCustomFieldKey = "";
      this.searchByCustomFieldText = "";
      this.searchByAssignedToMeText = false;
      this.searchByAssignedToBotText = false;
      this.searchByUnassignedConvoText = false;
      this.searchByFollowupText = false;
      this.searchByArchivedUsersText = false;
      this.subscriptionStatus = '';
      this.anySearchOrFilterIsApplied = false;
      this.filterVal = undefined;

      this.commonSearchFilterRenderKey += 1;
      this.empty_customersResults_like_arrays();

      if (this.liveChatConversationsView_type === "3tabView") {
        await this.fetchCustomers(null, 0, false, "activeChatsTab");
      } else {
        await this.fetchCustomers(null, 0, false);
      }

      await this.ensureActiveConversationVisible(this.active);
    },
    playUnreadMessageSound() {
      const audio = document.getElementById("customerUnReadMessagesAudio");
      if (audio && typeof audio.play === "function") {
        const playPromise = audio.play();
        if (playPromise && typeof playPromise.catch === "function") {
          playPromise.catch(() => {});
        }
      }
      const event = new CustomEvent("pingingLiveChat");
      document.dispatchEvent(event);
    },
    sortCustomersByLastReply(customers) {
      return customers.sort((a, b) => {
        const timeA = a.lastReplyTimestamp ? new Date(a.lastReplyTimestamp).getTime() : 0;
        const timeB = b.lastReplyTimestamp ? new Date(b.lastReplyTimestamp).getTime() : 0;
        return timeB - timeA; // Latest on top
      });
    },
    checkIfAnyFilterIsApplied() {
      return this.searchByAssignedToMeText || 
             this.searchByAssignedToBotText || 
             this.searchByUnassignedConvoText || 
             this.searchByFollowupText || 
             this.searchByArchivedUsersText || 
             this.searchByAssignedToAgentID !== '' || 
             this.searchByFirstNameText !== '' || 
             this.searchByLastNameText !== '' || 
             this.searchByEmailText !== '' || 
             this.searchByTagText !== '' || 
             (this.searchByCustomFieldKey !== '' && this.searchByCustomFieldText !== '') || 
             this.selectedChannel !== 'all';
    },
    checkIfChatIsAssignedToMe(customer) {
      //assigned to me wheather its active true or false
      if(!customer) return false;
      if(customer.active) return false; // if active true, then it should not be assigned to me, it's assigned to bot
      if(customer.retarget) return false;
      if(customer.assigned_to?.id && customer.assigned_to.id == this.roleDetails.id) return true;
      return false;
    },
    checkIfChatIsUnassigned(customer) {
      //unassigned to any agent and active false
      //or assigned to my group (means current loggedin agent's group)
      if(!customer) return false;
      if(customer.active) return false; // if active true, then it should not be assigned to me, it's assigned to bot
      if(customer.retarget) return false;
      if(customer.assigned_to == null) return true;
      if(customer.assigned_to?.id && customer.assigned_to.id == this.group_id) return true;
      return false;
    },
    checkIfChatIsAssignedToBot(customer) {
      //active true and (not assigned to me or my group)
      if(!customer) return false;
      if(customer.retarget) return false;
      if(!customer.active) return false;
      return true;
    },
    adjustNew_customerData_intoTabs(data){
      if(typeof data != 'undefined'){
        if(this.show_liveChatConversationsListAreaTabs == true){
          for(var i1=0; i1 < this.activeChatsTab_customersResults.length; i1++){
            if(data.conversationid == this.activeChatsTab_customersResults[i1].conversationid){
              this.activeChatsTab_customersResults.splice(i1,1);

              break;
            }
          }

          for(var i2=0; i2 < this.requestsChatsTab_customersResults.length; i2++){
            if(data.conversationid == this.requestsChatsTab_customersResults[i2].conversationid){
              this.requestsChatsTab_customersResults.splice(i2,1);

              break;
            }
          }

          for(var i3=0; i3 < this.botChatsTab_customersResults.length; i3++){
            if(data.conversationid == this.botChatsTab_customersResults[i3].conversationid){
              this.botChatsTab_customersResults.splice(i3,1);

              break;
            }
          }

          if(this.checkIfChatIsAssignedToMe(data) == true){
            this.activeChatsTab_customersResults.unshift(data);
          }
          else if(this.checkIfChatIsUnassigned(data) == true){
            this.requestsChatsTab_customersResults.unshift(data);
          }
          else if(this.checkIfChatIsAssignedToBot(data) == true){
            this.botChatsTab_customersResults.unshift(data);
          }
        }
      }
    },
    checkAndAddTheSingleCustomerDataToRelevantTabArray(data,type){
      if(typeof data != 'undefined'){
        if(this.show_liveChatConversationsListAreaTabs == true){
          if(!data.count) data.count = 0;
          data.count++;

          if(this.checkIfChatIsAssignedToMe(data) == true){
            if(type == 'unshift'){
              this.activeChatsTab_customersResults.unshift(data);
            }
            else{
              this.activeChatsTab_customersResults.push(data);
            }
          }
          else if(this.checkIfChatIsUnassigned(data) == true){
            if(type == 'unshift'){
              this.requestsChatsTab_customersResults.unshift(data);
            }
            else{
              this.requestsChatsTab_customersResults.push(data);
            }
          }
          else if(this.checkIfChatIsAssignedToBot(data) == true){
            if(type == 'unshift'){
              this.botChatsTab_customersResults.unshift(data);
            }
            else{
              this.botChatsTab_customersResults.push(data);
            }
          }
        }
      }
    },
    async parseNewConversationDataReceivedFromPusher(data,comingViaAgentRouting){
      var force_playSoundNotification_bool = false;
      let shouldPlaySoundInTabs = false;

      if(comingViaAgentRouting != true){
        comingViaAgentRouting = false;
      }

      var canProceedAndCallApiBool = true;

      if(typeof data.conversation_active != 'undefined'){
        if(data.conversation_active == null){
          data.conversation_active = true;
        }
      }

      var conversationidFoundBool = false;

      for (var i = 0; i < this.customersResults.length; i++) {
        if (data.conversationid == this.customersResults[i].conversationid) {
          conversationidFoundBool = true;
          break;
        }
      }

      if (conversationidFoundBool == false) {
        if ((this.searchByArchivedUsersText == true || this.searchByFollowupText == true || this.searchByFirstNameText != '' || this.searchByLastNameText != '' || this.searchByEmailText != '' || this.searchByTagText != '' || (this.searchByCustomFieldKey != '' && this.searchByCustomFieldText != ''))) {
          canProceedAndCallApiBool = false;
        }
        else if (this.searchByAssignedToBotText == true) {
          if (typeof data.conversation_active != 'undefined') {
            if (data.conversation_active == false) {
              canProceedAndCallApiBool = false;
            }
          }
        }
      }
      else{
        
      }

      if(typeof data.marketing_opt_in_state === 'undefined' && typeof data.marketing_opt_in !== 'undefined'){
        //data.marketing_opt_in_state = data.marketing_opt_in;
      }
      //here we are just updating marketing opt-in status for a conversation listed on left panel of live chat (conversations list)
      const tempData = {
        conversation_id: data.conversationid,
        marketing_opt_in_status: data.marketing_opt_in_state
      };
      this.updateCustomerMarketingOptinStatusHandler(tempData);

      if(!this.customersResultsLoading && canProceedAndCallApiBool == true){
        //"api/get-conversation" call used to be here... we removed it for the optimization
        
        conversationidFoundBool = false;

        var result = {
          conversation: data
        };

        if(typeof result.conversation.active != 'undefined'){
          if(result.conversation.active == null){
            result.conversation.active = true;
          }
        }
        else if(typeof data.conversation_active != 'undefined'){
          result.conversation.active = data.conversation_active;
        }
        else if(typeof data.active != 'undefined'){
          result.conversation.active = data.active;
        }

        for (var i2 = 0; i2 < this.customersResults.length; i2++) {
          if (data.conversationid == this.customersResults[i2].conversationid) {
            conversationidFoundBool = true;

            result = {
              conversation: this.customersResults[i2]
            };

            if(typeof data.email != 'undefined' && data.email != null && data.email != 'None' && data.email != ''){
              result.conversation.email = data.email;
            }
            else{
              result.conversation.email = "unrecorded";
            }

            if(typeof data.image != 'undefined' && data.image != null && data.image != 'None' && data.image != ''){
              result.conversation.image = data.image;
            }
            else{
              result.conversation.image = "";
            }

            if(typeof data.name != 'undefined' && data.name != null && data.name != 'None' && data.name != ''){
              result.conversation.name = data.name;
            }
            else{
              result.conversation.name = "unrecorded";
            }

            if(typeof data.mobile != 'undefined' && data.mobile != null && data.mobile != 'None' && data.mobile != ''){
              result.conversation.mobile = data.mobile;
            }
            else{
              result.conversation.mobile = "";
            }

            if(typeof data.mobilecountrycode != 'undefined' && data.mobilecountrycode != null && data.mobilecountrycode != 'None' && data.mobilecountrycode != ''){
              result.conversation.mobilecountrycode = data.mobilecountrycode;
            }
            else{
              result.conversation.mobilecountrycode = "";
            }

            result.conversation['count'] = this.customersResults[i2].count;

            let this_is_status_message = false;
            if(typeof data.template != 'undefined'){
              if(typeof data.template.type != 'undefined'){
                if(data.template.type == 'status'){
                  this_is_status_message = true;
                }
              }
            }

            if(this_is_status_message == false){
              result.conversation.lastReplyTimestamp = data.created;
              result.conversation.userReplyTimestamp = data.created;
            }

            if(typeof data.assigned_to != 'undefined' && data.assigned_to != null){
              result.conversation.assigned_to = data.assigned_to;
            }

            if(typeof data.agent != 'undefined' && data.agent != null){
              result.conversation.assigned_to = data.agent;
            }
            
            if(typeof data.conversation_active != 'undefined'){
              result.conversation.active = data.conversation_active;
            }

            force_playSoundNotification_bool = false;
            if (typeof data.vertex != 'undefined') {
              if (data.vertex == 2125 || data.vertex == '2125' || data.vertex == 20080 || data.vertex == '20080') {
                result.conversation.active = false;

                force_playSoundNotification_bool = true;
              }
            }

            if((this.calculate24Plus1RuleForCustomer(result.conversation.userReplyTimestamp) >= 24) || (this.calculate24Plus1RuleForCustomer(result.conversation.userReplyTimestamp) >= 24 && result.conversation.channel == 'whatsapp')){
              //result.conversation.active = false;
              result.conversation.page_msg_subscription_restriction = true;

              if(result.conversation.channel == 'whatsapp'){
                if(data.conversationid == this.$route.query.conversation){
                  this.isWhatsappChat_old24H = true;
                }
              }
            }
            else{
              result.conversation.page_msg_subscription_restriction = false;

              if(result.conversation.channel == 'whatsapp' && data.replied == false){
                if(data.conversationid == this.$route.query.conversation){
                  this.isWhatsappChat_old24H = false;
                  //this.isWhatsappChat_sendTemplate = false;
                }
              }
            }

            if (result.conversation.conversationid == this.$route.query.conversation) {
              result.conversation.currentlyOpendChat = true;

              //result.conversation.active = true;

              this.activeCustomer = result.conversation;
            } else {
              result.conversation.currentlyOpendChat = false;
            }

            this.customersResults[i2] = result.conversation;

            //moving this customer to top of list - start
            var a = this.customersResults.splice(i2, 1);
            this.customersResults.unshift(a[0]);

            var temp_customersArr_a = uniqueObjectiveArray(this.customersResults,'id');
            this.customersResults = this.sortCustomersByLastReply(temp_customersArr_a);
            
            this.adjustNew_customerData_intoTabs(result.conversation);
            
            // Sort tab arrays after adjustment
            this.activeChatsTab_customersResults = this.sortCustomersByLastReply(this.activeChatsTab_customersResults);
            this.requestsChatsTab_customersResults = this.sortCustomersByLastReply(this.requestsChatsTab_customersResults);
            this.botChatsTab_customersResults = this.sortCustomersByLastReply(this.botChatsTab_customersResults);
            //moving this customer to top of list - end

            if (result.conversation.conversationid != this.$route.query.conversation) {

              if(!this.show_liveChatConversationsListAreaTabs) {
                for (var i4 = 0; i4 < this.customersResults.length; i4++) {
                  var currentCount = 0;

                  if (comingViaAgentRouting == false) {
                    if (this.customersResults[i4].conversationid == data.conversationid) {
                      if ((result.conversation.active == true && data.stuckerror == true && data.replied == false) || (result.conversation.active == false && data.replied == false) || (force_playSoundNotification_bool == true && (this.checkIfChatIsAssignedToMe(result.conversation) == true || this.checkIfChatIsUnassigned(result.conversation) == true))) {
                        currentCount = this.customersResults[i4].count;

                        if (currentCount == 0) {
                          currentCount = 1;
                        } else {
                          currentCount = parseInt(currentCount);
                          currentCount = currentCount + 1;
                        }
                        this.customersResults[i4].count = currentCount;

                        document.getElementById("customerUnReadMessagesAudio").play();
                        const event = new CustomEvent("pingingLiveChat");
                        document.dispatchEvent(event);
                      }
                    }
                    else{
                      if(result.conversation.active == false && data.replied == false){
                        document.getElementById("customerUnReadMessagesAudio").play();
                        const event = new CustomEvent("pingingLiveChat");
                        document.dispatchEvent(event);
                      }
                    }
                  }
                  else{
                    if (result.conversation.active == false) {
                      currentCount = this.customersResults[i4].count;

                      if (currentCount == 0) {
                        currentCount = 1;
                      } else {
                        currentCount = parseInt(currentCount);
                        currentCount = currentCount + 1;
                      }

                      this.customersResults[i4].count = currentCount;

                      document.getElementById("customerUnReadMessagesAudio").play();
                      const event = new CustomEvent("pingingLiveChat");
                      document.dispatchEvent(event);
                    }
                  }
                }
              } else {
                for (var i4a = 0; i4a < this.activeChatsTab_customersResults.length; i4a++) {
                  var currentActiveCount = 0;

                  if (comingViaAgentRouting == false) {
                    if (this.activeChatsTab_customersResults[i4a].conversationid == data.conversationid) {
                      if ((result.conversation.active == true && data.stuckerror == true && data.replied == false) || (result.conversation.active == false && data.replied == false)) {
                        currentActiveCount = this.activeChatsTab_customersResults[i4a].count;

                        if (currentActiveCount == 0) {
                          currentActiveCount = 1;
                        } else {
                          currentActiveCount = parseInt(currentActiveCount);
                          currentActiveCount = currentActiveCount + 1;
                        }

                        this.activeChatsTab_customersResults[i4a].count = currentActiveCount;

                        shouldPlaySoundInTabs = true;
                      }
                    }
                  }
                  else{
                    if (result.conversation.active == false) {
                      currentActiveCount = this.activeChatsTab_customersResults[i4a].count;

                      if (currentActiveCount == 0) {
                        currentActiveCount = 1;
                      } else {
                        currentActiveCount = parseInt(currentActiveCount);
                        currentActiveCount = currentActiveCount + 1;
                      }
                      
                      this.activeChatsTab_customersResults[i4a].count = currentActiveCount;

                      shouldPlaySoundInTabs = true;
                    }
                  }
                }

                for (var i4b = 0; i4b < this.requestsChatsTab_customersResults.length; i4b++) {
                  var currentReqCount = 0;

                  if (comingViaAgentRouting == false) {
                    if (this.requestsChatsTab_customersResults[i4b].conversationid == data.conversationid) {
                      if ((result.conversation.active == true && data.stuckerror == true && data.replied == false) || (result.conversation.active == false && data.replied == false)) {
                        currentReqCount = this.requestsChatsTab_customersResults[i4b].count;

                        if (currentReqCount == 0) {
                          currentReqCount = 1;
                        } else {
                          currentReqCount = parseInt(currentReqCount);
                          currentReqCount = currentReqCount + 1;
                        }
                        
                        this.requestsChatsTab_customersResults[i4b].count = currentReqCount;

                        shouldPlaySoundInTabs = true;
                      }
                    }
                  }
                  else{
                    if (result.conversation.active == false) {
                      currentReqCount = this.requestsChatsTab_customersResults[i4b].count;

                      if (currentReqCount == 0) {
                        currentReqCount = 1;
                      } else {
                        currentReqCount = parseInt(currentReqCount);
                        currentReqCount = currentReqCount + 1;
                      }
                      
                      this.requestsChatsTab_customersResults[i4b].count = currentReqCount;

                      shouldPlaySoundInTabs = true;
                    }
                  }
                }

                for (var i4c = 0; i4c < this.botChatsTab_customersResults.length; i4c++) {
                  var currentBotCount = 0;

                  if (comingViaAgentRouting == false) {
                    if (this.botChatsTab_customersResults[i4c].conversationid == data.conversationid) {
                      if ((result.conversation.active == true && data.stuckerror == true && data.replied == false) || (result.conversation.active == false && data.replied == false)) {
                        currentBotCount = this.botChatsTab_customersResults[i4c].count;

                        if (currentBotCount == 0) {
                          currentBotCount = 1;
                        } else {
                          currentBotCount = parseInt(currentBotCount);
                          currentBotCount = currentBotCount + 1;
                        }
                        
                        this.botChatsTab_customersResults[i4c].count = currentBotCount;

                        shouldPlaySoundInTabs = true;
                      }
                    }
                  }
                  else{
                    if (result.conversation.active == false) {
                      currentBotCount = this.botChatsTab_customersResults[i4c].count;

                      if (currentBotCount == 0) {
                        currentBotCount = 1;
                      } else {
                        currentBotCount = parseInt(currentBotCount);
                        currentBotCount = currentBotCount + 1;
                      }
                      
                      this.botChatsTab_customersResults[i4c].count = currentBotCount;

                      shouldPlaySoundInTabs = true;
                    }
                  }
                }

                if (shouldPlaySoundInTabs) {
                  this.playUnreadMessageSound();
                }
              }
            }

            //this.distribute_customersResults_intoTabs(this.customersResults);

            break;
          }
        }
        if (!conversationidFoundBool){
          // Don't inject new conversations when any search or filter is applied.
          // Exception: a channel-only filter is handled downstream (channel-matching branch),
          // so we must not block here when selectedChannel is the sole active filter.
          const hasNonChannelFilter = this.searchByAssignedToMeText ||
            this.searchByAssignedToBotText ||
            this.searchByUnassignedConvoText ||
            this.searchByFollowupText ||
            this.searchByArchivedUsersText ||
            this.searchByAssignedToAgentID !== '' ||
            this.searchByFirstNameText !== '' ||
            this.searchByLastNameText !== '' ||
            this.searchByEmailText !== '' ||
            this.searchByTagText !== '' ||
            (this.searchByCustomFieldKey !== '' && this.searchByCustomFieldText !== '');
          if(hasNonChannelFilter || this.searchByMobileNumberText !== "") {
            this.playUnreadMessageSound();
            return;
          }
          
          console.info('new coming chat...LCH');
          result.conversation.id = result.conversation.conversationid;
          result.conversation.currentlyOpendChat = false;

          if(typeof data.email != 'undefined' && data.email != null && data.email != 'None' && data.email != ''){
            result.conversation.email = data.email;
          }
          else{
            result.conversation.email = "unrecorded";
          }

          if(typeof data.image != 'undefined' && data.image != null && data.image != 'None' && data.image != ''){
            result.conversation.image = data.image;
          }
          else{
            result.conversation.image = "";
          }

          if(typeof data.name != 'undefined' && data.name != null && data.name != 'None' && data.name != ''){
            result.conversation.name = data.name;
          }
          else{
            result.conversation.name = "unrecorded";
          }

          if(typeof data.mobile != 'undefined' && data.mobile != null && data.mobile != 'None' && data.mobile != ''){
            result.conversation.mobile = data.mobile;
          }
          else{
            result.conversation.mobile = "";
          }

          if(typeof data.mobilecountrycode != 'undefined' && data.mobilecountrycode != null && data.mobilecountrycode != 'None' && data.mobilecountrycode != ''){
            result.conversation.mobilecountrycode = data.mobilecountrycode;
          }
          else{
            result.conversation.mobilecountrycode = "";
          }

          if (typeof data.conversation_active != 'undefined') {
            result.conversation.active = data.conversation_active;
          }

          result.conversation.channel_id = data.pageid;
          result.conversation.channel = this.getChannelFromPageActive(data.pageid);

          let this_is_status_message = false;
          //can't check this here otherwise I will have nothing to put in these 2 variables "lastReplyTimestamp" & "userReplyTimestamp"
          /* if(typeof data.template != 'undefined'){
            if(typeof data.template.type != 'undefined'){
              if(data.template.type == 'status'){
                this_is_status_message = true;
              }
            }
          } */

          if(this_is_status_message == false){
            result.conversation.lastReplyTimestamp = data.created;
            result.conversation.userReplyTimestamp = data.created;
          }

          if((this.calculate24Plus1RuleForCustomer(result.conversation.userReplyTimestamp) >= 24) || (this.calculate24Plus1RuleForCustomer(result.conversation.userReplyTimestamp) >= 24 && result.conversation.channel == 'whatsapp')){
            //result.conversation.active = false;
            result.conversation.page_msg_subscription_restriction = true;

            if(result.conversation.channel == 'whatsapp'){
              this.isWhatsappChat_old24H = true;
            }
          }
          else{
            result.conversation.page_msg_subscription_restriction = false;

            if(result.conversation.channel == 'whatsapp' && data.replied == false){
              this.isWhatsappChat_old24H = false;
              //this.isWhatsappChat_sendTemplate = false;
            }
          }

          if(typeof data.agent != 'undefined' && data.agent != null){
            result.conversation.assigned_to = data.agent;
          }

          force_playSoundNotification_bool = false;
          if(typeof data.vertex != 'undefined'){
            if(data.vertex == 2125 || data.vertex == '2125' || data.vertex == 20080 || data.vertex == '20080'){
              result.conversation.active = false;

              force_playSoundNotification_bool = true;
            }
          }

          // Initialize unread count for the new conversation card.
          // Set to 1 when the message is inbound (customer sent it, not agent) and
          // this conversation is not the one currently open in the chat window.
          if (data.replied == false && result.conversation.conversationid != this.$route.query.conversation) {
            result.conversation.count = 1;
          } else {
            result.conversation.count = 0;
          }
          
          //console.log("proceed here");
          var iAmTheAssignedAgentTothisOne = true;

          if (this.agentFocusedMode == true) {
            if(comingViaAgentRouting == true){
              this.customersResults.unshift(result.conversation);
              this.customersResults = this.sortCustomersByLastReply(this.customersResults);

              this.checkAndAddTheSingleCustomerDataToRelevantTabArray(result.conversation, 'unshift');
              
              // Sort tab arrays
              this.activeChatsTab_customersResults = this.sortCustomersByLastReply(this.activeChatsTab_customersResults);
              this.requestsChatsTab_customersResults = this.sortCustomersByLastReply(this.requestsChatsTab_customersResults);
              this.botChatsTab_customersResults = this.sortCustomersByLastReply(this.botChatsTab_customersResults);

              this.activeCustomer = result.conversation;

              document.getElementById("customerUnReadMessagesAudio").play();
              const event = new CustomEvent("pingingLiveChat");
              document.dispatchEvent(event);
            }
            else{
              if (result.conversation.assigned_to != null && Object.keys(result.conversation.assigned_to).length > 0 && result.conversation.active == false) {
                iAmTheAssignedAgentTothisOne = true;
                if (this.roleDetails.id == result.conversation.assigned_to.id) {
                  iAmTheAssignedAgentTothisOne = true;
                } else {
                  iAmTheAssignedAgentTothisOne = false;
                }

                if (iAmTheAssignedAgentTothisOne == true) {
                  this.customersResults.unshift(result.conversation);
                  this.customersResults = this.sortCustomersByLastReply(this.customersResults);
                  
                  this.checkAndAddTheSingleCustomerDataToRelevantTabArray(result.conversation, 'unshift');
                  
                  // Sort tab arrays
                  this.activeChatsTab_customersResults = this.sortCustomersByLastReply(this.activeChatsTab_customersResults);
                  this.requestsChatsTab_customersResults = this.sortCustomersByLastReply(this.requestsChatsTab_customersResults);
                  this.botChatsTab_customersResults = this.sortCustomersByLastReply(this.botChatsTab_customersResults);
                  
                  this.activeCustomer = result.conversation;
                }
              }
            }
          }
          else {
            this.activeCustomer = result.conversation;

            if (this.searchByArchivedUsersText == true || this.searchByFollowupText == true || this.searchByFirstNameText != '' || this.searchByLastNameText != '' || this.searchByEmailText != '' || this.searchByTagText != '' || (this.searchByCustomFieldKey != '' && this.searchByCustomFieldText != '')) {
              //no need to show new conversation in this case
            } else if (this.searchByAssignedToBotText == true && result.conversation.active == true) {
              this.customersResults.unshift(result.conversation);
              this.customersResults = this.sortCustomersByLastReply(this.customersResults);

              this.checkAndAddTheSingleCustomerDataToRelevantTabArray(result.conversation, 'unshift');
              
              // Sort tab arrays
              this.activeChatsTab_customersResults = this.sortCustomersByLastReply(this.activeChatsTab_customersResults);
              this.requestsChatsTab_customersResults = this.sortCustomersByLastReply(this.requestsChatsTab_customersResults);
              this.botChatsTab_customersResults = this.sortCustomersByLastReply(this.botChatsTab_customersResults);
              this.playUnreadMessageSound();
            } else if (this.searchByUnassignedConvoText == true && (result.conversation.active == false && result.conversation.assigned_to == null)) {
              this.customersResults.unshift(result.conversation);
              this.customersResults = this.sortCustomersByLastReply(this.customersResults);

              this.checkAndAddTheSingleCustomerDataToRelevantTabArray(result.conversation, 'unshift');
              
              // Sort tab arrays
              this.activeChatsTab_customersResults = this.sortCustomersByLastReply(this.activeChatsTab_customersResults);
              this.requestsChatsTab_customersResults = this.sortCustomersByLastReply(this.requestsChatsTab_customersResults);
              this.botChatsTab_customersResults = this.sortCustomersByLastReply(this.botChatsTab_customersResults);

              this.playUnreadMessageSound();
            } else if (this.searchByAssignedToMeText == true) {
              if (result.conversation.assigned_to != null && Object.keys(result.conversation.assigned_to).length > 0) {
                iAmTheAssignedAgentTothisOne = true;
                if (this.roleDetails.id == result.conversation.assigned_to.id) {
                  iAmTheAssignedAgentTothisOne = true;
                } else {
                  iAmTheAssignedAgentTothisOne = false;
                }

                if (iAmTheAssignedAgentTothisOne == true) {
                  this.customersResults.unshift(result.conversation);
                  this.customersResults = this.sortCustomersByLastReply(this.customersResults);

                  this.checkAndAddTheSingleCustomerDataToRelevantTabArray(result.conversation, 'unshift');
                  
                  // Sort tab arrays
                  this.activeChatsTab_customersResults = this.sortCustomersByLastReply(this.activeChatsTab_customersResults);
                  this.requestsChatsTab_customersResults = this.sortCustomersByLastReply(this.requestsChatsTab_customersResults);
                  this.botChatsTab_customersResults = this.sortCustomersByLastReply(this.botChatsTab_customersResults);

                  this.playUnreadMessageSound();
                }
              }
            } else if (this.searchByAssignedToAgentID != '') {
              if (result.conversation.assigned_to != null && Object.keys(result.conversation.assigned_to).length > 0) {
                if (this.roleDetails.id == result.conversation.assigned_to.id) {
                  this.customersResults.unshift(result.conversation);
                  this.customersResults = this.sortCustomersByLastReply(this.customersResults);

                  this.checkAndAddTheSingleCustomerDataToRelevantTabArray(result.conversation, 'unshift');
                  
                  // Sort tab arrays
                  this.activeChatsTab_customersResults = this.sortCustomersByLastReply(this.activeChatsTab_customersResults);
                  this.requestsChatsTab_customersResults = this.sortCustomersByLastReply(this.requestsChatsTab_customersResults);
                  this.botChatsTab_customersResults = this.sortCustomersByLastReply(this.botChatsTab_customersResults);

                  this.playUnreadMessageSound();
                }
              }
            } else if (this.selectedChannel != 'all' && (this.selectedChannel == result.conversation.channel || this.selectedChannel == result.conversation.channel_id)) {
              this.customersResults.unshift(result.conversation);
              this.customersResults = this.sortCustomersByLastReply(this.customersResults);

              this.checkAndAddTheSingleCustomerDataToRelevantTabArray(result.conversation, 'unshift');
              
              // Sort tab arrays
              this.activeChatsTab_customersResults = this.sortCustomersByLastReply(this.activeChatsTab_customersResults);
              this.requestsChatsTab_customersResults = this.sortCustomersByLastReply(this.requestsChatsTab_customersResults);
              this.botChatsTab_customersResults = this.sortCustomersByLastReply(this.botChatsTab_customersResults);

              this.playUnreadMessageSound();
            } else if (this.checkIfAnyFilterIsApplied() == false) {
              if(result.conversation.retarget === true){
                //do nothing because this conversation is resolved
              }
              else{
                this.customersResults.unshift(result.conversation);
                this.customersResults = this.sortCustomersByLastReply(this.customersResults);
              }

              //console.log("active: "+ result.conversation.active);
              //console.log("assigned_to: "+ result.conversation.assigned_to);
              this.checkAndAddTheSingleCustomerDataToRelevantTabArray(result.conversation, 'unshift');
              
              // Sort tab arrays after adding new conversation
              this.activeChatsTab_customersResults = this.sortCustomersByLastReply(this.activeChatsTab_customersResults);
              this.requestsChatsTab_customersResults = this.sortCustomersByLastReply(this.requestsChatsTab_customersResults);
              this.botChatsTab_customersResults = this.sortCustomersByLastReply(this.botChatsTab_customersResults);
              
              this.playUnreadMessageSound();
            }
          }
        }
      }
    },
    // ---- CommonSearchFilter event handlers ----
    onSearchBarSearch(params) {
      this.searchByFirstNameText = params.searchByFirstNameText || '';
      this.searchByLastNameText = params.searchByLastNameText || '';
      this.searchByEmailText = params.searchByEmailText || '';
      this.searchByMobileNumberText = params.searchByMobileNumberText || '';
      this.searchByTagText = params.searchByTagText || '';
      this.searchByCustomFieldKey = params.searchByCustomFieldKey || '';
      this.searchByCustomFieldText = params.searchByCustomFieldText || '';
      this.searchByAssignedToAgentText = params.searchByAssignedToAgentText || '';
      this.searchByAssignedToAgentID = params.searchByAssignedToAgentID || '';
      this.selectedChannel = params.selectedChannel || 'all';
      this.searchByAssignedToMeText = params.searchByAssignedToMeText || false;
      this.searchByAssignedToBotText = params.searchByAssignedToBotText || false;
      this.searchByUnassignedConvoText = params.searchByUnassignedConvoText || false;
      this.searchByFollowupText = params.searchByFollowupText || false;
      this.searchByArchivedUsersText = params.searchByArchivedUsersText || false;
      this.subscriptionStatus = params.subscriptionStatus || '';
      this.filterVal = undefined;

      this.$emit("onFilterCustomers");
      this.empty_customersResults_like_arrays();
      this.fetchCustomers(null, 0, false);
    },
    onSearchBarFilter(params) {
      this.searchByFirstNameText = params.searchByFirstNameText || '';
      this.searchByLastNameText = params.searchByLastNameText || '';
      this.searchByEmailText = params.searchByEmailText || '';
      this.searchByMobileNumberText = params.searchByMobileNumberText || '';
      this.searchByTagText = params.searchByTagText || '';
      this.searchByCustomFieldKey = params.searchByCustomFieldKey || '';
      this.searchByCustomFieldText = params.searchByCustomFieldText || '';
      this.searchByAssignedToMeText = params.searchByAssignedToMeText || false;
      this.searchByAssignedToBotText = params.searchByAssignedToBotText || false;
      this.searchByAssignedToAgentText = params.searchByAssignedToAgentText || '';
      this.searchByAssignedToAgentID = params.searchByAssignedToAgentID || '';
      this.searchByUnassignedConvoText = params.searchByUnassignedConvoText || false;
      this.searchByFollowupText = params.searchByFollowupText || false;
      this.searchByArchivedUsersText = params.searchByArchivedUsersText || false;
      this.subscriptionStatus = params.subscriptionStatus || '';
      this.selectedChannel = params.selectedChannel || 'all';

      this.$emit("onFilterCustomers");
      this.empty_customersResults_like_arrays();
      this.fetchCustomers(null, 0, false);
    },
    async onSearchBarClear() {
      this.$emit("onClearFilter");

      this.searchByFirstNameText = "";
      this.searchByLastNameText = "";
      this.searchByEmailText = "";
      this.searchByMobileNumberText = "";
      this.searchByTagText = "";
      this.searchByAssignedToAgentText = "";
      this.searchByAssignedToAgentID = "";
      this.selectedChannel = "all";
      this.searchByCustomFieldKey = "";
      this.searchByCustomFieldText = "";
      this.searchByAssignedToMeText = false;
      this.searchByAssignedToBotText = false;
      this.searchByUnassignedConvoText = false;
      this.searchByFollowupText = false;
      this.searchByArchivedUsersText = false;
      this.subscriptionStatus = '';
      this.filterVal = undefined;

      this.empty_customersResults_like_arrays();

      if (this.liveChatConversationsView_type === "3tabView") {
        await this.fetchCustomers(null, 0, false, "activeChatsTab");
      } else {
        await this.fetchCustomers(null, 0, false);
      }
    },
    async init() {
      if(useAuthStore().isAdmin) {
        this.liveChatConversationsView_type = "1tabView";
        this.show_liveChatConversationsListAreaTabs = false;
      } else {
        this.liveChatConversationsView_type = "3tabView";
        this.show_liveChatConversationsListAreaTabs = true;
      }

      this.agentFocusedMode = false;

      this.empty_customersResults_like_arrays();

      if (this.liveChatConversationsView_type === "3tabView") {
        await this.fetchCustomers(null, 0, true, "activeChatsTab");
      } else {
        await this.fetchCustomers(null, 0, true);
      }
    },
    async newMessageHandler(e) {
      this.parseNewConversationDataReceivedFromPusher(e.detail, false);
    },
    async newMessageHandler_via_agentRouting(e) {
      this.parseNewConversationDataReceivedFromPusher(e.detail, true);
    },
    async removeConversationHandler(e) {
      this.hideResolvedConversationFromLiveChat(e.detail);
    },
    async reassignConversationHandler(e) {
      this.hideReAssignedConversationFromLiveChat(e.detail);
    },
    async pre_updateCustomerMarketingOptinStatusHandler(e) {
      this.updateCustomerMarketingOptinStatusHandler(e.detail);
    },
    async refreshCustomersHandler(e) {
      const action = e.detail?.action || 'connect';
      const channel = e.detail?.channel || e.detail?.channelType || 'unknown';
      console.log(`Refreshing customers due to channel ${action}:`, channel, e.detail);
      await this.doRefresh({ target: { complete: () => {} } });
    },
    async refreshPageHandler(e) {
      console.log("Refresh page event received from header:", e.detail);
      await this.doRefresh({ target: { complete: () => {} } });
      
      // Dispatch completion event
      const refreshCompleteEvent = new CustomEvent("refresh-page-complete", {
        detail: { source: 'livechat_refresh_complete' }
      });
      document.dispatchEvent(refreshCompleteEvent);
    },
    async updateCustomerMarketingOptinStatusHandler(e) {
      for(var i=0; i < this.customersResults?.length; i++){
        if(e.conversation_id == this.customersResults[i].conversationid){
          this.customersResults[i].marketing_opt_in_state = e.marketing_opt_in_status;

          break;
        }
      }

      if(this.show_liveChatConversationsListAreaTabs == true){
        for(var i1=0; i1 < this.activeChatsTab_customersResults.length; i1++){
          if(e.conversation_id == this.activeChatsTab_customersResults[i1].conversationid){
            this.activeChatsTab_customersResults[i1].marketing_opt_in_state = e.marketing_opt_in_status;

            break;
          }
        }

        for(var i2=0; i2 < this.requestsChatsTab_customersResults.length; i2++){
          if(e.conversation_id == this.requestsChatsTab_customersResults[i2].conversationid){
            this.requestsChatsTab_customersResults[i2].marketing_opt_in_state = e.marketing_opt_in_status;

            break;
          }
        }

        for(var i3=0; i3 < this.botChatsTab_customersResults.length; i3++){
          if(e.conversation_id == this.botChatsTab_customersResults[i3].conversationid){
            this.botChatsTab_customersResults[i3].marketing_opt_in_state = e.marketing_opt_in_status;

            break;
          }
        }
      }

      if(this.activeCustomer.conversationid == e.conversation_id){
        this.activeCustomer.marketing_opt_in_state = e.marketing_opt_in_status;

        for(var i = 0; i < this.activeCustomer.all_platforms?.length; i++){
          if(this.activeCustomer.all_platforms[i].conversation_key === e.conversation_id){
            this.activeCustomer.all_platforms[i].marketing_opt_in_state = e.marketing_opt_in_status;
          }
        }
      }
    },
    hideResolvedConversationFromLiveChat(data) {
      for(var i=0; i < this.customersResults?.length; i++){
        if(data.conversationid == this.customersResults[i].conversationid){
          this.customersResults.splice(i,1);

          this.removeItemFromAllTabArrays(data.conversationid);

          break;
        }
      }

      if(this.$route.query.conversation == data.conversationid){
        this.activeCustomer = {};
      }
    },
    async hideReAssignedConversationFromLiveChat(data){
      setTimeout(() => {
        if(this.$route.query.conversation == data.conversationid){
          this.activeCustomer = {};
        }
        
        for(var i=0; i < this.customersResults.length; i++){
          if(data.conversationid == this.customersResults[i].conversationid){
            this.customersResults.splice(i,1);

            this.removeItemFromAllTabArrays(data.conversationid);

            break;
          }
        }
      }, 10);
    },
    removeItemFromAllTabArrays(conversationid){
      if(typeof conversationid != 'undefined'){
        if(this.show_liveChatConversationsListAreaTabs == true){
          for(var i1=0; i1 < this.activeChatsTab_customersResults.length; i1++){
            if(conversationid == this.activeChatsTab_customersResults[i1].conversationid){
              this.activeChatsTab_customersResults.splice(i1,1);

              break;
            }
          }

          for(var i2=0; i2 < this.requestsChatsTab_customersResults.length; i2++){
            if(conversationid == this.requestsChatsTab_customersResults[i2].conversationid){
              this.requestsChatsTab_customersResults.splice(i2,1);

              break;
            }
          }

          for(var i3=0; i3 < this.botChatsTab_customersResults.length; i3++){
            if(conversationid == this.botChatsTab_customersResults[i3].conversationid){
              this.botChatsTab_customersResults.splice(i3,1);

              break;
            }
          }
        }
      }
    },
    async fetchCustomers(event, pageOffset, firstTime, tabBasedFilter) {
      try {
        this.loadingCustomers = true;
        if (!event) {
          useUIStore().updateLoading({ isLoading: true, message: 'Loading...' });
        }

        if (typeof tabBasedFilter == "undefined") {
          tabBasedFilter = "";
        }

        const pageSize = 20;

        var reqBody = {
          channel: this.selectedChannel,
          size: pageSize,
          retarget: "false",
          minimal: 'false',
        };

        if (typeof pageOffset !== "undefined" && pageOffset > 1) {
          reqBody["offset"] = pageSize * (pageOffset - 1);
        }
        if (!pageOffset) {
          if (tabBasedFilter == "activeChatsTab") {
            this.activeChatsTab_nextCursor = null;
          } else if (tabBasedFilter == "requestsChatsTab") {
            this.requestsChatsTab_nextCursor = null;
          } else if (tabBasedFilter == "botChatsTab") {
            this.botChatsTab_nextCursor = null;
          } else {
            this.nextCursor = null;
          }
        }

        if (tabBasedFilter == "activeChatsTab") {
          if (this.activeChatsTab_nextCursor) {
            reqBody["cursor"] = this.activeChatsTab_nextCursor;
          }
        } else if (tabBasedFilter == "requestsChatsTab") {
          if (this.requestsChatsTab_nextCursor) {
            reqBody["cursor"] = this.requestsChatsTab_nextCursor;
          }
        } else if (tabBasedFilter == "botChatsTab") {
          if (this.botChatsTab_nextCursor) {
            reqBody["cursor"] = this.botChatsTab_nextCursor;
          }
        } else {
          if (this.nextCursor) {
            reqBody["cursor"] = this.nextCursor;
          }
        }

        this.anySearchOrFilterIsApplied = false;

        if (this.searchByTagText != "") {
          this.anySearchOrFilterIsApplied = true;

          reqBody["tags"] = this.searchByTagText;

          reqBody["retarget"] = "both";
        } else if ( this.searchByCustomFieldKey != "" && this.searchByCustomFieldText != "" ) {
          this.anySearchOrFilterIsApplied = true;

          var arrData = [];
          var name = this.searchByCustomFieldKey.trim();
          var value = this.searchByCustomFieldText.trim();
          var objData = {
            name: name,
            value: value,
          };
          arrData.push(objData);

          reqBody["custom_tags"] = JSON.stringify(arrData);

          reqBody["retarget"] = "both";
        } else if (this.searchByFirstNameText != "") {
          this.anySearchOrFilterIsApplied = true;

          reqBody["first_name"] = this.searchByFirstNameText.toLowerCase();

          reqBody["retarget"] = "both";
        } else if (this.searchByLastNameText != "") {
          this.anySearchOrFilterIsApplied = true;

          reqBody["last_name"] = this.searchByLastNameText.toLowerCase();

          reqBody["retarget"] = "both";
        } else if (this.searchByEmailText != "") {
          this.anySearchOrFilterIsApplied = true;

          reqBody["email"] = this.searchByEmailText.toLowerCase();

          reqBody["retarget"] = "both";
        } else if (this.searchByMobileNumberText != ""){
          this.anySearchOrFilterIsApplied = true;

          reqBody["mobile_number"] = this.searchByMobileNumberText.replace(/\s+/g, '').toLowerCase();

          reqBody["retarget"] = "both";

        } else if (this.searchByAssignedToMeText == true || tabBasedFilter == "activeChatsTab") {
          if (tabBasedFilter != "activeChatsTab") {
            this.anySearchOrFilterIsApplied = true;
          }

          reqBody["assigned_to_me"] = "0";
        } else if (this.searchByFollowupText == true) {
          this.anySearchOrFilterIsApplied = true;

          reqBody["followup"] = "true";
        } else if (this.searchByArchivedUsersText == true) {
          this.anySearchOrFilterIsApplied = true;

          reqBody["retarget"] = "true";
        } else if (
          this.searchByAssignedToBotText == true ||
          tabBasedFilter == "botChatsTab"
        ) {
          if (tabBasedFilter != "botChatsTab") {
            this.anySearchOrFilterIsApplied = true;
          }

          reqBody["agent"] = "bot";
        } else if (this.searchByAssignedToAgentID != "") {
          this.anySearchOrFilterIsApplied = true;

          reqBody["agent"] = this.searchByAssignedToAgentID;
        } else if (
          this.searchByUnassignedConvoText == true ||
          tabBasedFilter == "requestsChatsTab"
        ) {
          if (tabBasedFilter != "requestsChatsTab") {
            this.anySearchOrFilterIsApplied = true;
          }

          reqBody["agent"] = "unassigned";
        }

        if (this.subscriptionStatus != "") {
          this.anySearchOrFilterIsApplied = true;

          reqBody["subscription_status"] = this.subscriptionStatus;
        }

        if (this.agentFocusedMode == true) {
          this.anySearchOrFilterIsApplied = true;

          reqBody["assigned_to_me"] = "0";

          this.show_liveChatConversationsListAreaTabs = false;
        } else {
          if (
            this.anySearchOrFilterIsApplied == true ||
            this.selectedChannel != "all"
          ) {
            this.anySearchOrFilterIsApplied = true;
            this.show_liveChatConversationsListAreaTabs = false;
          } else {
            if(useAuthStore().isAdmin == true){
              this.show_liveChatConversationsListAreaTabs = false;
            } else {
              this.show_liveChatConversationsListAreaTabs = true;
            }
          }
        }
        const params = {
          ...reqBody,
        };
        const response = await apiInterceptor.get( environment("VUE_APP_API_URL") + "crm/v2/customers/", { params } );
        if (response.user_info) {
          if (
            tabBasedFilter == "" &&
            this.anySearchOrFilterIsApplied == false &&
            pageOffset == 0
          ) {
            this.fetchCustomerApiCalledFor_activeChatsTab = false;
            this.fetchCustomerApiCalledFor_requestsChatsTab = false;
            this.fetchCustomerApiCalledFor_botChatsTab = false;
          } else if (tabBasedFilter == "activeChatsTab") {
            this.fetchCustomerApiCalledFor_activeChatsTab = true;
          } else if (tabBasedFilter == "requestsChatsTab") {
            this.fetchCustomerApiCalledFor_requestsChatsTab = true;
          } else if (tabBasedFilter == "botChatsTab") {
            this.fetchCustomerApiCalledFor_botChatsTab = true;
          }

          if (tabBasedFilter == "activeChatsTab") {
            this.activeChatsTab_nextCursor = response.next;
          } else if (tabBasedFilter == "requestsChatsTab") {
            this.requestsChatsTab_nextCursor = response.next;
          } else if (tabBasedFilter == "botChatsTab") {
            this.botChatsTab_nextCursor = response.next;
          } else {
            this.nextCursor = response.next;
          }
          const customerInfo = response.user_info;
          for (var user of customerInfo) {
            if (typeof user.conversationid == "undefined") {
              user.conversationid = user.id;
            }

            if (user.name == "" || user.name == null || user.name == "None") {
              user.name = "unrecorded";
            }

            if (
              user.email == "" ||
              user.email == null ||
              user.email == "None"
            ) {
              user.email = "unrecorded";
            }

            if(user.count === undefined || user.count === null) user.count = 0;

            var conversationidFoundBool = false;

            for (var i = 0; i < this.customersResults.length; i++) {
              if (
                user.conversationid == this.customersResults[i].conversationid
              ) {
                conversationidFoundBool = true;
              }
            }

            if (conversationidFoundBool == false) {
              if (typeof user.active != "undefined") {
                if (user.active == null) {
                  user.active = true;
                }
              }

              var obj = user;
              obj.id = user.conversationid;
              obj.currentlyOpendChat = false;
              obj.channel_id = obj.channel;
              obj.channel = this.getChannelFromPageActive(obj.channel, true);

              if ( this.calculate24Plus1RuleForCustomer(user.userReplyTimestamp) >= 24 ) {
                if (obj.channel == "whatsapp") {
                  //obj.active = false;
                  obj.page_msg_subscription_restriction = true;
                } else {
                  obj.page_msg_subscription_restriction = false;
                }
              } else {
                obj.page_msg_subscription_restriction = false;
              }

              //pending: for later when we merge conversations list view & single detailed view
              /* if(this.pageInboxPriorityConversationId != obj.conversationid){
                //pending: here we can filter out customers whos channel is not permitted to loggedin agent
                this.customersResults.push(obj);
                this.checkAndAddTheSingleCustomerDataToRelevantTabArray(obj,'push');
              } */
                  
              this.customersResults.push(obj);
              if (tabBasedFilter == "activeChatsTab") {
                this.activeChatsTab_customersResults.push(obj);
              } else if (tabBasedFilter == "requestsChatsTab") {
                this.requestsChatsTab_customersResults.push(obj);
              } else if (tabBasedFilter == "botChatsTab") {
                this.botChatsTab_customersResults.push(obj);
              } else {
                this.checkAndAddTheSingleCustomerDataToRelevantTabArray( obj, "push" );
              }
            }
          }

          // Sort all arrays by lastReplyTimestamp
          this.customersResults = this.sortCustomersByLastReply(this.customersResults);
          if (tabBasedFilter == "activeChatsTab") {
            this.activeChatsTab_customersResults = this.sortCustomersByLastReply(this.activeChatsTab_customersResults);
          } else if (tabBasedFilter == "requestsChatsTab") {
            this.requestsChatsTab_customersResults = this.sortCustomersByLastReply(this.requestsChatsTab_customersResults);
          } else if (tabBasedFilter == "botChatsTab") {
            this.botChatsTab_customersResults = this.sortCustomersByLastReply(this.botChatsTab_customersResults);
          } else {
            // Sort tab arrays when no specific filter is applied
            this.activeChatsTab_customersResults = this.sortCustomersByLastReply(this.activeChatsTab_customersResults);
            this.requestsChatsTab_customersResults = this.sortCustomersByLastReply(this.requestsChatsTab_customersResults);
            this.botChatsTab_customersResults = this.sortCustomersByLastReply(this.botChatsTab_customersResults);
          }

          if (typeof pageOffset != "undefined") {
            if (pageOffset == 1) {
              if (tabBasedFilter == "activeChatsTab") {
                this.activeChatsTab_currentPaginationNumber = 1;
              } else if (tabBasedFilter == "requestsChatsTab") {
                this.requestsChatsTab_currentPaginationNumber = 1;
              } else if (tabBasedFilter == "botChatsTab") {
                this.botChatsTab_currentPaginationNumber = 1;
              } else {
                this.currentPaginationNumber = 1;
              }
            } else if (pageOffset != 0) {
              if (tabBasedFilter == "activeChatsTab") {
                this.activeChatsTab_currentPaginationNumber = pageOffset;
              } else if (tabBasedFilter == "requestsChatsTab") {
                this.requestsChatsTab_currentPaginationNumber = pageOffset;
              } else if (tabBasedFilter == "botChatsTab") {
                this.botChatsTab_currentPaginationNumber = pageOffset;
              } else {
                this.currentPaginationNumber = pageOffset;
              }
            }
          }

          if (customerInfo.length > 0) {
            this.customersResultsLoading = false;
            this.activeChatsTab_customersResultsLoading = false;
            this.requestsChatsTab_customersResultsLoading = false;
            this.botChatsTab_customersResultsLoading = false;

            if (response.next) {
              if (tabBasedFilter == "activeChatsTab") {
                this.activeChatsTab_totalCustomers_loadMore = true;
              } else if (tabBasedFilter == "requestsChatsTab") {
                this.requestsChatsTab_totalCustomers_loadMore = true;
              } else if (tabBasedFilter == "botChatsTab") {
                this.botChatsTab_totalCustomers_loadMore = true;
              } else {
                this.totalCustomers_loadMore = true;

                if (pageOffset == 0) {
                  this.activeChatsTab_totalCustomers_loadMore = true;
                  this.requestsChatsTab_totalCustomers_loadMore = true;
                  this.botChatsTab_totalCustomers_loadMore = true;
                }
              }
            } else {
              if (tabBasedFilter == "activeChatsTab") {
                this.activeChatsTab_totalCustomers_loadMore = false;
              } else if (tabBasedFilter == "requestsChatsTab") {
                this.requestsChatsTab_totalCustomers_loadMore = false;
              } else if (tabBasedFilter == "botChatsTab") {
                this.botChatsTab_totalCustomers_loadMore = false;
              } else {
                this.totalCustomers_loadMore = false;

                if (pageOffset == 0) {
                  this.activeChatsTab_totalCustomers_loadMore = false;
                  this.requestsChatsTab_totalCustomers_loadMore = false;
                  this.botChatsTab_totalCustomers_loadMore = false;
                }
              }
            }
          } else {
            this.customersResultsLoading = false;
            this.activeChatsTab_customersResultsLoading = false;
            this.requestsChatsTab_customersResultsLoading = false;
            this.botChatsTab_customersResultsLoading = false;

            if (tabBasedFilter == "activeChatsTab") {
              this.activeChatsTab_totalCustomers_loadMore = false;
            } else if (tabBasedFilter == "requestsChatsTab") {
              this.requestsChatsTab_totalCustomers_loadMore = false;
            } else if (tabBasedFilter == "botChatsTab") {
              this.botChatsTab_totalCustomers_loadMore = false;
            } else {
              this.totalCustomers_loadMore = false;

              if (pageOffset == 0) {
                this.activeChatsTab_totalCustomers_loadMore = false;
                this.requestsChatsTab_totalCustomers_loadMore = false;
                this.botChatsTab_totalCustomers_loadMore = false;
              }
            }
          }

          //pending: @kru
          //this.setUnreadCountsOnPageLoadFromLocalStorage();

          if ( tabBasedFilter == "" && this.anySearchOrFilterIsApplied == false && pageOffset == 0 && this.show_liveChatConversationsListAreaTabs == true ) {
            //calling this to get more conversations if "assigned to me"
            await this.fetchCustomers( { target: { complete: () => {} } }, this.activeChatsTab_currentPaginationNumber + 1, false, "activeChatsTab" );
          }

          if ( this.anySearchOrFilterIsApplied == false && this.show_liveChatConversationsListAreaTabs == true ) {
            if (tabBasedFilter == "activeChatsTab") {
              await this.fetchCustomers({ target: { complete: () => {} } }, 0, firstTime, "requestsChatsTab");
            } else if (tabBasedFilter == "requestsChatsTab") {
              await this.fetchCustomers({ target: { complete: () => {} } }, 0, firstTime, "botChatsTab");
            } else if (tabBasedFilter == "botChatsTab") {
              //do nothing
            }
          }
          if ( (firstTime == true && this.show_liveChatConversationsListAreaTabs == true && tabBasedFilter == "botChatsTab") || (firstTime == true && this.show_liveChatConversationsListAreaTabs == false) ) {
            //pending: @kru
            //this.fetchTagCloudOfMerchant();
            //this.fetchCustomFieldCloudOfMerchant();
          }
        } else {
          console.error("Response:", response);

          useUIStore().updateLoading({ isLoading: false });
          this.customersResultsLoading = false;
          this.activeChatsTab_customersResultsLoading = false;
          this.requestsChatsTab_customersResultsLoading = false;
          this.botChatsTab_customersResultsLoading = false;

          if (tabBasedFilter == "activeChatsTab") {
            this.fetchCustomerApiCalledFor_activeChatsTab = true;
          } else if (tabBasedFilter == "requestsChatsTab") {
            this.fetchCustomerApiCalledFor_requestsChatsTab = true;
          } else if (tabBasedFilter == "botChatsTab") {
            this.fetchCustomerApiCalledFor_botChatsTab = true;
          }

          this.activeChatsTab_totalCustomers_loadMore = false;
          this.requestsChatsTab_totalCustomers_loadMore = false;
          this.botChatsTab_totalCustomers_loadMore = false;
          this.totalCustomers_loadMore = false;
        }
      } catch (error) {
        useUIStore().updateToast({
          open: true,
          message: error.message,
          type: "danger"
        })
      } finally {
        useUIStore().updateLoading({ isLoading: false });
        if (event) event.target.complete();
        this.loadingCustomers = false;
      }
    },
    // ---- infinite scroll on the conversations list ----
    observeCustomersListSentinel() {
      if (typeof IntersectionObserver == "undefined") return;

      const sentinel = this.$refs.customersListSentinel;
      if (!sentinel || sentinel === this.observedCustomersListSentinel) return;

      if (!this.customersListObserver) {
        this.customersListObserver = new IntersectionObserver(
          (entries) => {
            const entry = entries[0];
            if (!entry) return;

            this.customersListSentinelIsVisible = entry.isIntersecting;

            if (entry.isIntersecting) {
              this.maybeLoadMoreCustomers();
            } else {
              // scrolled away from the end of the list, allow auto loading again
              this.customersListAutoLoadBlocked = false;
            }
          },
          { root: this.$refs.liveChatHomeWrapper, rootMargin: "100px" }
        );
      } else {
        this.customersListObserver.disconnect();
      }

      this.observedCustomersListSentinel = sentinel;
      this.customersListObserver.observe(sentinel);
    },
    maybeLoadMoreCustomers() {
      if (this.customersListSentinelIsVisible == false) return;
      if (this.customersListAutoLoadBlocked == true) return;
      if (this.isLoadingMoreCustomers == true || this.loadingCustomers == true) return;
      if (this.hasMoreCustomersToLoad == false) return;

      this.loadMoreCustomers();
    },
    async loadMoreCustomers() {
      const tabBasedFilter = this.currentListTabBasedFilter;
      const nextPageNumber = this.currentListPaginationNumber + 1;
      const countBeforeLoad = this.currentListLoadedCount;

      this.isLoadingMoreCustomers = true;

      try {
        // passing a fake event keeps the full page "Loading..." overlay away,
        // fetchCustomers only calls event.target.complete() on it
        await this.fetchCustomers({ target: { complete: () => {} } }, nextPageNumber, false, tabBasedFilter);

        if (this.currentListLoadedCount <= countBeforeLoad) {
          // nothing new came back, stop auto loading until the user scrolls again
          this.customersListAutoLoadBlocked = true;
        }
      } finally {
        this.isLoadingMoreCustomers = false;
      }
    },
    pullRefreshingHandler() {
      this.loadingCustomers = true;
    },
    async doRefresh(event) {
      this.pullRefreshingHandler();
      this.cloneCustomersResults = [...this.customersResults];
      await this.init();
      this.cloneCustomersResults = [this.cloneCustomersResults[0]];
      this.pullRefreshingHandler();
      event.target.complete();
    },
    empty_customersResults_like_arrays() {
      this.customersResultsLoading = true;
      this.activeChatsTab_customersResultsLoading = true;
      this.requestsChatsTab_customersResultsLoading = true;
      this.botChatsTab_customersResultsLoading = true;
      this.customersResults = [];
      this.activeChatsTab_customersResults = [];
      this.requestsChatsTab_customersResults = [];
      this.botChatsTab_customersResults = [];
      this.activeCustomer = {};

      // reset pagination so infinite scroll starts from page 1 again
      this.currentPaginationNumber = 1;
      this.activeChatsTab_currentPaginationNumber = 1;
      this.requestsChatsTab_currentPaginationNumber = 1;
      this.botChatsTab_currentPaginationNumber = 1;
      this.nextCursor = undefined;
      this.activeChatsTab_nextCursor = undefined;
      this.requestsChatsTab_nextCursor = undefined;
      this.botChatsTab_nextCursor = undefined;
      this.totalCustomers_loadMore = false;
      this.activeChatsTab_totalCustomers_loadMore = false;
      this.requestsChatsTab_totalCustomers_loadMore = false;
      this.botChatsTab_totalCustomers_loadMore = false;
      this.customersListAutoLoadBlocked = false;
    },
    distribute_customersResults_intoTabs(data) {
      if (typeof data != "undefined") {
        if (this.show_liveChatConversationsListAreaTabs == true) {
          this.activeChatsTab_customersResults = [];
          this.requestsChatsTab_customersResults = [];
          this.botChatsTab_customersResults = [];

          for (var i = 0; i < data.length; i++) {
            if (this.checkIfChatIsAssignedToMe(data[i]) == true) {
              this.activeChatsTab_customersResults.push(data[i]);
            } else if (this.checkIfChatIsUnassigned(data[i]) == true) {
              this.requestsChatsTab_customersResults.push(data[i]);
            } else if (this.checkIfChatIsAssignedToBot(data[i]) == true) {
              this.botChatsTab_customersResults.push(data[i]);
            }
          }
        }
      }
    },
    markRead(id) {
      for (let i = 0; i < this.customersResults.length; i++) {
        if (id === this.customersResults[i].conversationid) {
          this.customersResults[i].read = true;
          break;
        }
      }
      for (let i = 0; i < this.activeChatsTab_customersResults.length; i++) {
        if (id === this.activeChatsTab_customersResults[i].conversationid) {
          this.activeChatsTab_customersResults[i].read = true;
          break;
        }
      }
      for (let i = 0; i < this.requestsChatsTab_customersResults.length; i++) {
        if (id === this.requestsChatsTab_customersResults[i].conversationid) {
          this.requestsChatsTab_customersResults[i].read = true;
          break;
        }
      }
      for (let i = 0; i < this.botChatsTab_customersResults.length; i++) {
        if (id === this.botChatsTab_customersResults[i].conversationid) {
          this.botChatsTab_customersResults[i].read = true;
          break;
        }
      }
    },
    checkAndShowTabSpecificUnreadMessageBubble(tabName){
      switch(tabName) {
        case 'activeChatsTab': return this.activeChatsTab_customersResults.some((e) => e.count && e.count > 0);
        case 'requestsChatsTab': return this.requestsChatsTab_customersResults.some((e) => e.count && e.count > 0);
        case 'botChatsTab': return this.botChatsTab_customersResults.some((e) => e.count && e.count > 0);
      }
    }
  },
  beforeUnmount() {
    document.removeEventListener("new-message", this.newMessageHandler, true);
    document.removeEventListener(
      "new-message-via-agent-routing",
      this.newMessageHandler_via_agentRouting,
      true
    );
    document.removeEventListener(
      "remove-conversation",
      this.removeConversationHandler,
      true
    );
    document.removeEventListener(
      "reassign-conversation",
      this.reassignConversationHandler,
      true
    );
    document.removeEventListener(
      "refresh-customers",
      this.refreshCustomersHandler,
      true
    );
    document.removeEventListener(
      "refresh-page",
      this.refreshPageHandler,
      true
    );
    document.removeEventListener(
      "customer_info_update",
      this.pre_updateCustomerMarketingOptinStatusHandler,
      true
    );

    if (this.customersListObserver) {
      this.customersListObserver.disconnect();
      this.customersListObserver = null;
      this.observedCustomersListSentinel = null;
    }
  },
};
</script>
<style scoped>
.live-chat-home-wrapper {
  height: 100%;
  overflow-y: auto;
  background: var(--white);
}
.liveChatListActive{
  background: var(--purple-opac);
}
.liveChatList, .liveChatListActive{
  padding: 0px 20px;
  border-bottom: 1px solid var(--background-primary);
  cursor: pointer;
}
.chat-list {
  padding: 0;
}
.custom-tabs {
  display: flex;
  border-bottom: 2px solid var(--background-primary);
  background: var(--white);
  position: sticky;
  top: 0;
  z-index: 5;
}
.custom-tab {
  flex: 1;
  text-align: center;
  padding: 12px 8px;
  font-size: 13px;
  font-weight: 500;
  color: var(--gray-04);
  cursor: pointer;
  position: relative;
  transition: color 0.2s;
  white-space: nowrap;
}
.custom-tab.active {
  color: var(--purple);
}
.custom-tab.active::after {
  content: '';
  position: absolute;
  bottom: -2px;
  left: 0;
  right: 0;
  height: 2px;
  background: var(--purple);
}
.emptyFiltersImage {
  max-width: 200px;
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}
.sub-title{
  font-size: 14px;
  color: var(--gray-04);
  font-weight: 400;
  line-height: 16px;
}
.emptyResults{
  width: 100%;
  padding: 15px;
}
.custResultsArea{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  align-content: center;
  padding: 30px;
  gap: 20px;
}
.customersListSentinel {
  width: 100%;
  height: 1px;
}
.customersListLoadingMore {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  padding: 15px;
}
.customersListLoadingMore .sub-title {
  margin: 0;
}
a{
  text-decoration: none;
}
</style>